import settings from "../../config/settings"
const axios = require("axios");

export default class SettingService {

    getUserDetails = async (): Promise<any> => {
        let token: any = localStorage.getItem('keycloak-token');
        const body = {
          token: token
      }
        return await axios.get(settings.apiUrl + 'user/get-user',
      {
          headers:{
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + token
          }
      }
      ).then((resp: any) => resp.data);
      }

      
    verifyPassword = async (data: any) => {
        let token = localStorage.getItem('keycloak-token');
        return await axios.post(settings.apiUrl + 'user/verify-password', data,
        {
            headers:{
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            }
        }
        ).then((resp: any) => resp.status).catch((e:any) => {
            return 401
        });    
    }

    updatePassword =async (data:any) => {
        let token = localStorage.getItem('keycloak-token');
        return await axios.put(settings.apiUrl + 'user/update-password', data,
        {
            headers:{
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            }
        }
        ).then((resp: any) => resp)
    }

    updateUserSettings = async(email: any, data: any) =>{
        let token = localStorage.getItem('keycloak-token');
        const params = new URLSearchParams({
            email: email
        })
        return await axios.put(settings.apiUrl + 'user/user-settings?'+ params, data,
        {
            headers:{
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            }
        }
        ).then((resp: any) => resp.status)
    }

    getSubUsers = async () =>{
        let token = localStorage.getItem('keycloak-token');
        const params = new URLSearchParams({
            manager_id: localStorage.getItem('userId')!
        })

        return await axios.get(settings.apiUrl + 'user/sub-users?' + params,
        {
            headers:{
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            }
        }
        ).then((resp: any) => resp.data)

    }

    getSingleSubUser = async (username: string) =>{
        let token = localStorage.getItem('keycloak-token');
        const params = new URLSearchParams({
            username: username
        })

        return await axios.get(settings.apiUrl + 'user/single-sub-users?' + params,
        {
            headers:{
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            }
        }
        ).then((resp: any) => resp.data)

    }

    createSubUser =async (data:any) => {
        let token = localStorage.getItem('keycloak-token');
        const params = new URLSearchParams({
            manager_id: localStorage.getItem('userId')!
        })
        
        return await axios.post(settings.apiUrl + 'user/create-sub-user?' + params, data,
        {
            headers:{
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            }
        }
        ).then((resp: any) => resp.status).catch((e:any) => {
            return 400
        });  
    }

    editSubUser =async (username:string, data:any) => {
        let token = localStorage.getItem('keycloak-token');
        const params = new URLSearchParams({
            username: username
        })
        
        return await axios.put(settings.apiUrl + 'user/sub-users?' + params, data,
        {
            headers:{
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            }
        }
        ).then((resp: any) => resp.status).catch((e:any) => {
            return 400
        });  
    }

    deleteSubUser =async (username:string, keycloakId:any) => {
        let token = localStorage.getItem('keycloak-token');
        const params = new URLSearchParams({
            username: username,
            keycloak_id: keycloakId
        })
        
        return await axios.delete(settings.apiUrl + 'user/sub-users?' + params,
        {
            headers:{
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            }
        }
        ).then((resp: any) => resp.status).catch((e:any) => {
            return 400
        });  
    }
}